import React from 'react';
import { motion, useScroll } from 'framer-motion';
export function ScrollProgress() {
  const {
    scrollYProgress
  } = useScroll();
  return <motion.div className="fixed top-0 left-0 right-0 h-[3px] bg-[#c9a961] z-[51] origin-left" style={{
    scaleX: scrollYProgress
  }} data-id="element-285" />;
}